export default __webpack_public_path__ + "static/media/pieczatka6.06855a58.gif";